export default class ProductPricesElements {
  /**
   * @type {{}}
   */
  #global;

  /**
   * @type {Set<HTMLElement>}
   */
  #elementsProcessed = new Set();

  /**
   * @param {string} selector
   */
  constructor(selector) {
    this.#global = window.Spurit.global;
    if (selector) {
      this.#global.selectors.add(selector, this.#global.constants.SELECTOR.PRODUCT_PRICE);
    }
  }

  /**
   * @param {function(HTMLElement)} callback
   */
  forEachElement(callback) {
    const processElements = () => this.#global.selectors
      .getTheLowestElements(this.#global.constants.SELECTOR.PRODUCT_PRICE)
      .forEach(element => {
        if (this.#elementsProcessed.has(element)) {
          return;
        }
        this.#elementsProcessed.add(element);
        callback(element);
      });
    processElements();
    this.#global.selectors.onElementsAppear(
      this.#global.constants.SELECTOR.PRODUCT_PRICE,
      processElements,
      this.#global.constants.SELECTOR_ALGORITHM.LOWEST
    );
  }

  /**
   * @param {HTMLElement} element
   * @return {boolean}
   */
  static shouldSkip(element) {
    return element.hasAttribute('data-integration-price-created') || element.hasAttribute('data-integration-price-saved');
  }
}